const KEY = "keves_recent_searches";
const MAX_STORED = 10;

export function getRecentSearches() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export function saveRecentSearch(item) {
  const current = getRecentSearches();

  // Deduplicate by type + id
  const filtered = current.filter(
    (x) => !(x.type === item.type && x.id === item.id)
  );

  const updated = [
    { ...item, savedAt: new Date().toISOString() },
    ...filtered,
  ].slice(0, MAX_STORED);

  localStorage.setItem(KEY, JSON.stringify(updated));
}

/**
 * Group recent searches by relative date.
 * Items without savedAt (legacy) fall into "Anteriores".
 */
export function groupRecentsByDate(recents) {
  const todayStr = new Date().toDateString();
  const yesterdayStr = new Date(Date.now() - 86_400_000).toDateString();

  const groups = { Hoy: [], Ayer: [], Anteriores: [] };

  for (const item of recents) {
    if (!item.savedAt) {
      groups.Anteriores.push(item);
      continue;
    }
    const d = new Date(item.savedAt).toDateString();
    if (d === todayStr) groups.Hoy.push(item);
    else if (d === yesterdayStr) groups.Ayer.push(item);
    else groups.Anteriores.push(item);
  }

  return Object.entries(groups).filter(([, items]) => items.length > 0);
}
